import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { useTenant } from "../lib/tenant.js";
import { useLoginContent } from "../templates/pages/login/useLoginContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/** Magic-link sign-in through the BFF, laid out by the storefront template this environment chose. */
export function LoginPage() {
  const { config } = useTenant();
  return (
    <PageTemplateView template={storefrontTemplateOf(config).login} content={useLoginContent()} />
  );
}
